import endpoints from '@/constants/endpoints';
import { ITEMS_TABLE_PAGE_LIMIT } from '@/utils/constants';
import axiosV2 from '../axiosv2';
import { ProductsBySellerResponse } from '../model/productsBySeller/productsBySellerDto';

export const getProductsBySeller = async (args: {
  pageNumber?: number;
  searchTerm?: string;
}): Promise<ProductsBySellerResponse> => {
  const endpoint = endpoints.catalog.getProductsBySeller;

  const response = await axiosV2.get<ProductsBySellerResponse>(endpoint, {
    params: {
      limit: ITEMS_TABLE_PAGE_LIMIT,
      page: args.pageNumber,
      ...(args.searchTerm && { query: `${args.searchTerm}` }),
    },
  });

  return response;
};
